const { config } = require('@xingternal/hops');

const getLoginUrl = ({ location }) =>
  `/login/go?dest_url=${encodeURI(location)}`;

const isPreview = () => config.appEnv === 'preview';
const isXingbox = () => config.appEnv === 'development_sandbox';
const isProduction = () => config.appEnv === 'production';

const getIndustryName = ({ intl, id }) =>
  intl.formatMessage({
    id: `INDUSTRY_${unscrambleId(id)}`,
  });

const removeSpecialCharsAndAccents = (str) =>
  str
    .normalize('NFD')
    .replace(/[^a-zA-Z0-9]/g, '-')
    .replace(/[\u0300-\u036f]/g, '');

const unscrambleId = (id) => id.split('.')[0];

module.exports = {
  isXingbox,
  getIndustryName,
  getLoginUrl,
  isPreview,
  removeSpecialCharsAndAccents,
  unscrambleId,
  isProduction,
};
